export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  FIREBASE: 'firebase_token',
  CUTOFF_TIME: 'cutoff_time',
}
